export function recoveryObservationFresh(value, now = Date.now()) {
  return value?.version === 1 && value.observationFresh === true && value.monitorLifecycle === 'running'
    && Number.isFinite(value.receivedAtEpochMs) && value.receivedAtEpochMs <= now
    && Number.isFinite(value.expiresAtEpochMs) && value.expiresAtEpochMs > now
    && value.expiresAtEpochMs <= value.receivedAtEpochMs + 60000;
}

export function recoveryFacts(value, now = Date.now()) {
  const fresh = recoveryObservationFresh(value, now);
  let setup = value?.observedAt ? 'Unknown (stale observation)' : 'Unknown (no target observation)';
  if (['stopped', 'failed'].includes(value?.monitorLifecycle)) setup = 'Unknown (monitor unavailable)';
  if (fresh) {
    setup = value.support === 'unsupported' ? 'Unsupported by this target'
      : value.recoveryEnabled === false ? 'Disabled'
      : value.recoveryEnabled !== true ? 'Unknown'
      : value.permissionGranted === false ? 'Permission missing'
      : value.permissionGranted !== true ? 'Permission unknown'
      : value.support !== 'setting_present' ? 'Enabled; support unknown' : 'Configured';
  }
  return { fresh, setup,
    permission: fresh && typeof value.permissionGranted === 'boolean' ? value.permissionGranted ? 'Granted' : 'Missing' : 'Unknown',
    debugging: fresh && typeof value.debuggingEnabled === 'boolean' ? value.debuggingEnabled ? 'Enabled' : 'Disabled' : 'Unknown' };
}

export const RECOVERY_REASONS = {
  unsupported_target: 'This target does not expose supported Wireless Debugging settings.',
  package_missing: 'The Suitestream app is not installed for the active Android user.',
  package_ambiguous: 'More than one Suitestream app is installed. Resolve the duplicate installation before setup.',
  android_user_unknown: 'The active Android user could not be verified.',
  target_scope_changed: 'The target app or Android user changed during setup. Check the saved result before retrying.',
  target_app_upgrade_required: 'Update the Suitestream app on this target before setting up recovery.',
  target_provider_unavailable: 'The target app could not respond to recovery setup.',
  target_readback_invalid: 'The target recovery response could not be verified.',
  permission_grant_failed: 'Android did not verify the required permission grant.',
  permission_missing: 'The target permission is missing. Enable recovery again over a verified connection.',
  preference_write_failed: 'The target could not verify that the recovery preference was saved.',
  agent_start_failed: 'The target recovery agent could not start.',
  monitor_not_running: 'The recovery preference was saved, but the target monitor is not running.',
  activation_readback_mismatch: 'The target did not retain the requested recovery preference.',
  connection_lost: 'The connection was lost before all recovery results could be verified.',
};

export const RECOVERY_OUTCOMES = {
  disabled: 'Recovery disabled', already_enabled: 'Debugging was already enabled', restored: 'Local restoration verified',
  enable_requested: 'Enablement requested; readback pending', verifying: 'Waiting for stable enablement',
  permission_missing: 'Permission missing', write_denied: 'Android denied the setting write',
  network_unavailable: 'Waiting for Wi-Fi', network_unknown: 'Wi-Fi readiness unknown',
  network_approval_required: 'Wi-Fi approval required', enable_not_retained: 'Enablement was not retained; Wi-Fi approval or firmware support may need attention',
  retry_exhausted: 'Retry limit reached', unsupported: 'Unsupported', support_unknown: 'Setting support unknown',
  read_failed: 'Local settings could not be read', write_rejected: 'Android rejected enablement',
  preference_write_failed: 'Recovery preference could not be saved', scheduler_unavailable: 'Recovery scheduling unavailable', stopped: 'Monitor stopped',
};
